const versione='10000000';

function Parametri(parametro, identitaSelezionata=[]) {
const versione=501

    //const urlbackendPrimario = 'https://h.massbroken.it:2003/ema/link_back_front.php';
const urlbackendPrimario = 'https://ema1.gestionesportiva.it/link_back_front.php?v=501';
    //const urlbackendPrimario = 'http://192.168.9.9/pubblico/ema/link_back_front.php';
    //const urlbackendPrimario = 'https://ema1.gestionesportiva.it/link_back_front.php';

const urlWebSocket = 'wss://ema1.gestionesportiva.it/ws';
    
    switch (parametro) {       
        case 'serverURL': 
            if (identitaSelezionata.urlbackend != undefined) {
                if (identitaSelezionata.urlbackend != "primario") return identitaSelezionata.urlbackend;
            }           
            return urlbackendPrimario;
        break;

        case 'serverURLPrimario': 
            return urlbackendPrimario;
        break;

        case 'urlWebSocket': 
            return urlWebSocket;
        break;

case 'release': return "P-"+versione; break;
    }
    return "";
}

export default Parametri;
